import React from 'react'
import AccessInput from '../../components/Inputs/AccessInput'
import { CustomCard } from '../../components/CustomCard/CustomCard';
import NumberOfResourcesByPlace from '../../components/Dashboard/NumberOfResourcesByPlace';
import NumberOfResourcesByHours from '../../components/Dashboard/NumberOfResourcesByHours';
import { havePermission } from '../../helpers/helpers';

const Dashboard = () => {

  const canViewResourcesPerOpening = havePermission(6);
  const canViewResourcesPerHours = havePermission(13);
  const canMakeAccess = havePermission(1);

  return (
    <div className='pt-4 pb-5 ps-4 pe-4'>
      <div className="row">
        {canMakeAccess && (
          <div className="col-lg-6">
            <AccessInput />
          </div>
        )}
      </div>
      <div className="row row-md-cols-1 gap-4">
        {canViewResourcesPerOpening && (
          <div className="col">
            <CustomCard classCard='h-100' withHeader={false}>
              <NumberOfResourcesByPlace />
            </CustomCard>
          </div>
        )}
        {canViewResourcesPerHours && (
          <div className="col">
            <CustomCard classCard='h-100' withHeader={false}>
              <NumberOfResourcesByHours />
            </CustomCard>
          </div>
        )}
      </div>
    </div >
  )
}

export default Dashboard